import { render, staticRenderFns } from "./view-voluntariado.vue?vue&type=template&id=8b7b97ee"
import script from "./view-voluntariado.vue?vue&type=script&lang=js"
export * from "./view-voluntariado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports